export enum ConfigurationType {
    Global = 'global',
    Page = 'page',
    Control = 'control'
}